export const DIV_MODAL_SELECTORS = {
   CSS_INPUT: '#classInput',
   STYLE_INPUT: '#styleInput',
   NODE_POS_INPUT: '#nodePosInput',
} as const;